import Vue from "vue"
import * as rt from "../../../routes/routes"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as ses from "../../../configurations/session/sessioncomplete"
import baseurl from "../../../configurations/baseurl/baseurl"


export const actions = {

    newPermission() {
        let permission = {
            Permissionname: $('.permissionname').val()
        }
        $('.creatingPermissionLoader').show()
        $('.creatingPermission').hide()
        baseurl
            .post(rt.newPermissions, permission)
            .then(res => {

                $('.creatingPermissionLoader').hide()
                $('.creatingPermission').show()
                $('.form-control').val("")
                if (res.data.code === 200) {
                    suc.permissionCreateSuccess()
                } else if (res.data.code === 403) {
                    ers.permissionExists()
                } else if (res.data.code === 404) {
                    ers.errorCreatingPermission()
                }else if(res.data.code === 405){
                    ers.noPermissionToCreate()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }
            })
    },

    loadPermissions({ commit }) {
        baseurl
            .get(rt.loadPermissions)
            .then(res => {
                $('.modulespermissionLoader').hide()
                $('.permissionsLoader').hide()
                if (res.data.code === 200) {
                    commit('STORE_PERMISSIONS', res.data.permissions)
                } else if (res.data.code === 404) {
                    ers.errorLoadingPermissions()
                }else if(res.data.code === 405){
                    ers.noPermissionToRead()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    deletePermission({ commit }, permId) {
        Vue.swal.fire({ title: 'Are you sure?', text: 'You want to delete this permission..?!', type: "warning", showCancelButton: true }).then(result => {
            if (result.value) {
                window.$("#permissionsLoaderModal").modal("show");
                baseurl
                    .get(rt.deletePermission + permId)
                    .then(res => {
                        window.$("#permissionsLoaderModal").modal("hide");
                        if (res.data.code === 200) {
                            suc.permissionDeleteSuccess()
                            setTimeout(() => {
                                $('.permissionsLoader').show()
                                setTimeout(() => {
                                    commit('STORE_PERMISSIONS', res.data.permissions)
                                    $('.permissionsLoader').hide()
                                }, 200);

                            }, 3000);

                        } else if (res.data.code === 404) {
                            ers.errorDeletingPermission()
                        }else if(res.data.code === 405){
                            ers.noPermissionToDelete()
                        } else if (res.data.code === 506) {
                            ses.sessionComplete()
                        }

                    })
            }
        })
    }
}

export default actions


// WEBPACK FOOTER //
// ./src/vuex/modules/permissions/actions.js